import { useState } from "react";
import './form.css'

const vehicle = {
    "oneWay": ["Sedan", "SUV", "Innova", "Luxury (Crysta)"],
    "round":["Sedan", "SUV", "Innova", "Luxury (Crysta)", "Traveller", "Tour Bus"]
}

export function OutStationForm(){
    
    const [trip, setTrip]=useState({
        type:"Outstation",
        date:"",
        time:"",
        pickLocation:"",
        dropLocation:"",
        triptype:"",
        vehicle:"",
        name:"",
        phone:""
    })

    const [tripSelect, setTripSelect] = useState(false)
    const [vehicleSelect, setVehicleSelect] = useState("oneWay")
    const [submitCheck, setSubmitCheck] = useState(false)

    const tripChange = (e) =>{
        const {name, value} = e.target
        setTrip((preData)=>({
            ...preData,
            [name]:value
        }))
        if(name==='triptype') {
            setTripSelect(true)
            setVehicleSelect(value)
        }
    }

    const tripSubmit = async(e) =>{
        e.preventDefault()
        setSubmitCheck(true)

        const formData = new FormData(e.target);
        formData.append("access_key", process.env.REACT_APP_KEY);
        
        const response = await fetch(process.env.REACT_APP_LINK, {
            method: "POST",
            body: formData
        });
        
        const data = await response.json();
      
        if (data.success) {
            setSubmitCheck(false)
            setTrip({
                type:"Outstation",
                date:"",
                time:"",
                pickLocation:"",
                dropLocation:"",
                triptype:"",
                vehicle:"",
                name:"",
                phone:""
            })
            alert(`Our Team will Contact you soon...
Feel free to call us...`)
        } else {
            console.log("Error", data);
            setSubmitCheck(false)
        }
    }


    return(
        <form className="form" onSubmit={tripSubmit}>
            <div className="inputMain">
                <div className='inputContaienr'>
                    <label>
                        Name
                    </label>
                    <input
                        type='text'
                        name='name'
                        value={trip.name}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        Phone Number
                    </label>
                    <input
                        type='text'
                        name='phone'
                        value={trip.phone}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr formTime'>
                    <div className='inputCol'>
                        <label>
                            PICKUP DATE
                        </label>
                        <input
                            type='date'
                            name='date'
                            value={trip.date}
                            onChange={tripChange}
                            required
                        />
                    </div>
                    <div className='inputCol'>
                        <label>
                            PICKUP TIME
                        </label>
                        <input
                            type='time'
                            name='time'
                            value={trip.time}
                            onChange={tripChange}
                            required
                        />
                    </div>                    
                </div>
                <div className='inputContaienr'>
                    <label>
                        PICKUP LOCATION
                    </label>
                    <input
                        type='text'
                        name='pickLocation'
                        value={trip.pickLocation}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        DROP-OFF LOCATION
                    </label>
                    <input
                        type='text'
                        name='dropLocation'
                        value={trip.dropLocation}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        TRIP TYPE
                    </label>
                    <select
                        name='triptype'
                        value={trip.triptype}
                        onChange={tripChange}
                        required
                    >
                        <option hidden value=''>Trip Type</option>
                        <option value='oneWay'>One-Way</option>
                        <option value='round'>Return</option>
                    </select>
                </div>
                <div className='inputContaienr'>
                    <label>
                        VEHICLE TYPE
                    </label>
                    <select
                        type='text'
                        name='vehicle'
                        value={trip.vehicle}
                        onChange={tripChange}
                        disabled={tripSelect?false:true}
                        required
                    >
                        <option hidden value=''>Vehicle Type</option>
                        {vehicle[vehicleSelect].map((item, key)=>(
                            <option key={key} value={item}>{item}</option>
                        ))}
                    </select>
                </div>                
            </div>
            <div className='inputContaienr submit'>
                <input
                    type="submit"
                    value="Book Now"
                    disabled={submitCheck}
                />
            </div>
        </form>
    )
}

export function Local(){
    const [trip, setTrip]=useState({
        type:"Local",
        date:"",
        time:"",
        pickLocation:"",
        dropLocation:"",
        triptype:"",
        vehicle:"",
        name:"",
        phone:""
    })

    const [submitCheck, setSubmitCheck] = useState(false)
    const [tripSelect, setTripSelect] = useState(false)
    const [vehicleSelect, setVehicleSelect] = useState("oneWay")

    const tripChange = (e) =>{
        const {name, value} = e.target
        setTrip((preData)=>({
            ...preData,
            [name]:value
        }))
        if(name==='triptype') {
            setTripSelect(true)
            setVehicleSelect(value)
        }
    }
    const tripSubmit = async(e) =>{
        e.preventDefault()
        setSubmitCheck(true)

        const formData = new FormData(e.target);
        formData.append("access_key", process.env.REACT_APP_KEY);
        
        const response = await fetch(process.env.REACT_APP_LINK, {
            method: "POST",
            body: formData
        });
        
        const data = await response.json();
      
        if (data.success) {
            setSubmitCheck(false)
            setTrip({
                type:"Local",
                date:"",
                time:"",
                pickLocation:"",
                dropLocation:"",
                triptype:"",
                vehicle:"",
                name:"",
                phone:""
            })
            alert(`Our Team will Contact you soon...
Feel free to call us...`)
        } else {
            console.log("Error", data);
            setSubmitCheck(false)
        }
    }


    return(
        <form className="form" onSubmit={tripSubmit}>
            <div className="inputMain">
                <div className='inputContaienr'>
                    <label>
                        Name
                    </label>
                    <input
                        type='text'
                        name='name'
                        value={trip.name}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        Phone Number
                    </label>
                    <input
                        type='text'
                        name='phone'
                        value={trip.phone}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr formTime'>
                    <div className='inputCol'>
                        <label>
                            PICKUP DATE
                        </label>
                        <input
                            type='date'
                            name='date'
                            value={trip.date}
                            onChange={tripChange}
                            required
                        />
                    </div>
                    <div className='inputCol'>
                        <label>
                            PICKUP TIME
                        </label>
                        <input
                            type='time'
                            name='time'
                            value={trip.time}
                            onChange={tripChange}
                            required
                        />
                    </div>                    
                </div>
                <div className='inputContaienr'>
                    <label>
                        PICKUP LOCATION
                    </label>
                    <input
                        type='text'
                        name='pickLocation'
                        value={trip.pickLocation}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        DROP-OFF LOCATION
                    </label>
                    <input
                        type='text'
                        name='dropLocation'
                        value={trip.dropLocation}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        TRIP TYPE
                    </label>
                    <select
                        name='triptype'
                        value={trip.triptype}
                        onChange={tripChange}
                        required
                    >
                        <option hidden value=''>Trip Type</option>
                        <option value='oneWay'>One-Way</option>
                        <option value='round'>Return</option>
                    </select>
                </div>
                <div className='inputContaienr'>
                    <label>
                        VEHICLE TYPE
                    </label>
                    <select
                        type='text'
                        name='vehicle'
                        value={trip.vehicle}
                        onChange={tripChange}
                        disabled={tripSelect?false:true}
                        required
                    >
                        <option hidden value=''>Vehicle Type</option>
                        {vehicle[vehicleSelect].map((item, key)=>(
                            <option key={key} value={item}>{item}</option>
                        ))}
                    </select>
                </div>                
            </div>
            <div className='inputContaienr submit'>
                <input
                    type="submit"
                    value="Book Now"
                    disabled={submitCheck}
                />
            </div>
        </form>
    )
}

export function Hour(){
    
    const [trip, setTrip]=useState({
        type:"Hours",
        date:"",
        time:"",
        pickLocation:"",
        hour:"",
        vehicle:"",
        name:"",
        phone:""
    })

    const [submitCheck, setSubmitCheck] = useState(false)
    // const [tripSelect, setTripSelect] = useState(false)
    const [vehicleSelect, setVehicleSelect] = useState("oneWay")

    const tripChange = (e) =>{
        const {name, value} = e.target
        setTrip((preData)=>({
            ...preData,
            [name]:value
        }))
        if(name==='triptype') {
            // setTripSelect(true)
            setVehicleSelect(value)
        }
    }

    const tripSubmit = async(e) =>{
        e.preventDefault()
        setSubmitCheck(true)

        const formData = new FormData(e.target);
        formData.append("access_key", process.env.REACT_APP_KEY);
        
        const response = await fetch(process.env.REACT_APP_LINK, {
            method: "POST",
            body: formData
        });
        
        const data = await response.json();
      
        if (data.success) {
            setSubmitCheck(false)
            setTrip({
                type:"Hours",
                date:"",
                time:"",
                pickLocation:"",
                hour:"",
                vehicle:"",
                name:"",
                phone:""
            })
            alert(`Our Team will Contact you soon...
Feel free to call us...`)
        } else {
            console.log("Error", data);
            setSubmitCheck(false)
        }
    }


    return(
        <form className="form" onSubmit={tripSubmit}>
            <div className="inputMain">
                <div className='inputContaienr'>
                    <label>
                        Name
                    </label>
                    <input
                        type='text'
                        name='name'
                        value={trip.name}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        Phone Number
                    </label>
                    <input
                        type='text'
                        name='phone'
                        value={trip.phone}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr formTime'>
                    <div className='inputCol'>
                        <label>
                            PICKUP DATE
                        </label>
                        <input
                            type='date'
                            name='date'
                            value={trip.date}
                            onChange={tripChange}
                            required
                        />
                    </div>
                    <div className='inputCol'>
                        <label>
                            PICKUP TIME
                        </label>
                        <input
                            type='time'
                            name='time'
                            value={trip.time}
                            onChange={tripChange}
                            required
                        />
                    </div>                    
                </div>
                <div className='inputContaienr'>
                    <label>
                        PICKUP LOCATION
                    </label>
                    <input
                        type='text'
                        name='pickLocation'
                        value={trip.pickLocation}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        DURATION (IN HOURS)
                    </label>
                    <input
                        type='number'
                        name='hour'
                        value={trip.hour}
                        onChange={tripChange}
                        required
                    />
                </div>
                <div className='inputContaienr'>
                    <label>
                        VEHICLE TYPE
                    </label>
                    <select
                        type='text'
                        name='vehicle'
                        value={trip.vehicle}
                        onChange={tripChange}
                        required
                    >
                        <option hidden value=''>Vehicle Type</option>
                        {vehicle[vehicleSelect].map((item, key)=>(
                            <option key={key} value={item}>{item}</option>
                        ))}
                    </select>
                </div>                
            </div>
            <div className='inputContaienr submit'>
                <input
                    type="submit"
                    value="Book Now"
                    disabled={submitCheck}
                />
            </div>
        </form>
    )
}